import React, { useState, useEffect } from 'react';
import { X, Zap, ArrowRight } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const DiscountBanner = ({ handleOpenModal }) => {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Показываем баннер через 1 секунду
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const handleOpenSpecialModal = () => {
        handleOpenModal("agenda", "discount_banner");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-bg-orange-600 tw-text-white tw-py-2 sm:tw-py-2 tw-z-10 tw-shadow-lg">
            <div className="tw-container tw-mx-auto tw-px-2 sm:tw-px-4">
                {/* Вариант для десктопа (скрыт на маленьких экранах) */}
                <div className="tw-hidden sm:tw-flex tw-items-center tw-justify-center tw-gap-2">
                    {/* Блок с иконкой и надписью о скидке */}
                    <div className="tw-flex tw-items-center tw-gap-1">
                        <Zap className="tw-w-4 tw-h-4" />
                        <span className="tw-bg-white tw-text-orange-600 tw-px-2 tw-py-1 tw-rounded-md tw-font-bold tw-whitespace-nowrap tw-text-sm">
                            EXCLUSIVE 25% DISCOUNT!
                        </span>
                    </div>

                    {/* Описание скидки */}
                    <p className="tw-text-sm tw-max-w-2xl tw-font-medium">
                        Want to learn more about the event? Leave your contact details – we’ll send you the agenda and a personalized offer with up to 25% discount.
                    </p>

                    {/* Блок с кнопками */}
                    <div className="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
                        <button
                            onClick={handleOpenSpecialModal}
                            className="tw-bg-white tw-text-orange-600 hover:tw-bg-orange-50 tw-px-3 tw-py-1 tw-rounded-md tw-transition-colors tw-font-bold tw-whitespace-nowrap tw-text-sm tw-flex tw-items-center"
                        >
                            Get Your Offer <ArrowRight className="tw-w-3 tw-h-3 tw-ml-1" />
                        </button>
                        <button
                            onClick={() => setIsVisible(false)}
                            className="tw-p-1 hover:tw-bg-orange-500 tw-rounded-full tw-transition-colors"
                        >
                            <X className="tw-w-4 tw-h-4" />
                        </button>
                    </div>
                </div>

                {/* Вариант для мобильных устройств */}
                <div className="sm:tw-hidden tw-flex tw-flex-col tw-items-center tw-gap-2">
                    <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
                        <div className="tw-flex tw-items-center">
                            <Zap className="tw-w-4 tw-h-4 tw-mr-1" />
                            <span className="tw-text-white tw-font-bold tw-text-sm">
                                25% DISCOUNT!
                            </span>
                        </div>
                        <button
                            onClick={() => setIsVisible(false)}
                            className="tw-flex tw-items-center tw-justify-center"
                        >
                            <X className="tw-w-4 tw-h-4" />
                        </button>
                    </div>

                    <button
                        onClick={handleOpenSpecialModal}
                        className="tw-bg-white tw-text-orange-600 tw-font-bold tw-text-sm tw-rounded-md tw-py-1 tw-px-3 tw-w-full tw-flex tw-items-center tw-justify-center"
                    >
                        Get Your Special Offer <ArrowRight className="tw-w-3 tw-h-3 tw-ml-1" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DiscountBanner;
